import { memo } from "react";

import { getFormatDate } from "@/helpers/utils";
import {
  RRD_LAYOUT_KEY,
  getRRDLayoutSpec,
  normalizeRRDPrintTypeContext,
} from "@/features/campaigns/direct-mail/rrd/utils/rrdLayoutHelper";
import RRDLayoutRenderer from "./layouts/RRDLayoutRenderer";
import type { RRDTemplateCommonProps } from "./rrdTemplateTypes";

type RRDDirectMailTemplateProps = RRDTemplateCommonProps & {
  readOnly?: boolean;
  fullWidth?: boolean;
};

function RRDDirectMailTemplate({
  heroImages = [],
  coupons = [],
  fixedImages = [],
  frontCouponExpirationDate,
  backCouponExpirationDate,
  printType,
  layoutKey,
  onRemoveAsset,
  readOnly = false,
  fullWidth = false,
}: RRDDirectMailTemplateProps) {
  const context = normalizeRRDPrintTypeContext({
    print_type: printType,
    layoutKey,
  });
  const layoutSpec =
    context.layoutSpec || getRRDLayoutSpec(RRD_LAYOUT_KEY.BASIC_POSTCARD_1H_6C);

  const frontExpirationDate = getFormatDate(frontCouponExpirationDate);
  const backExpirationDate = getFormatDate(
    backCouponExpirationDate || frontCouponExpirationDate
  );

  return (
    <RRDLayoutRenderer
      layoutSpec={layoutSpec}
      layoutKey={layoutKey}
      heroImages={heroImages}
      coupons={coupons}
      fixedImages={fixedImages}
      frontExpirationDate={frontExpirationDate}
      backExpirationDate={backExpirationDate}
      mode="desktop"
      onRemoveAsset={onRemoveAsset}
      readOnly={readOnly}
      fullWidth={fullWidth}
    />
  );
}

export default memo(RRDDirectMailTemplate);
